import { IconButton } from "@mui/material";
import React from "react";

export const ImageIconButton = ({ children, ...restProps }) => {
  return <IconButton {...restProps}>{children}</IconButton>;
};
